<form>
    <!--order form card-->
    <fadv-card>
        <!--order form header-->
        <fadv-card-header>
            <div class="card-header-formatting">
                <fadv-grid-row>
                    <fadv-grid-column style="padding-top: 16px; padding-bottom: 16px;">
                        <fadv-box p="small">
                            <fadv-typography style="text-align: center;" type="heading-small" variant="white">{{
                                orderHeaderVerbiage }}
                            </fadv-typography>
                            <div>
                                <fadv-typography style="text-align: center; display: block;" type="paragraph-medium"
                                    variant="white">
                                    {{ orderSubHeaderVerbiage}}
                                </fadv-typography>
                            </div>
                        </fadv-box>
                    </fadv-grid-column>
                </fadv-grid-row>
            </div>
        </fadv-card-header>

        <fadv-box p="large">

            <!--if invite-->
            <div>
                <app-candidateinvite [candidateinvite]="candidate">
                </app-candidateinvite>
                <fadv-grid>
                    <fadv-grid-row>
                        <fadv-grid-col style="padding-left: 15px" alignment="left">
                            <fadv-typography>If your applicant does not have an email or access to internet, you must
                                utilize the <a class="link" role="button" (click)="selectOrderType('online')">direct
                                    data entry workflow.</a>
                            </fadv-typography>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col>
                            <fadv-box p="large" style="text-align: center;">
                                <a nohref style="cursor:pointer;color:blue;text-decoration:underline;padding-top: 2%;"
                                    (click)="handleApplicantDocPreview()">
                                    View a copy of the disclosure and authorization forms provided to the applicant</a>
                            </fadv-box>
                        </fadv-grid-col>
                    </fadv-grid-row>
                </fadv-grid>
            </div>
        </fadv-box>
    </fadv-card>
</form>
<fadv-grid>
    <fadv-grid-row style="padding-top: 5%; padding-bottom: 5%">
        <fadv-grid-col alignment="{{backButtonAlignment}}" id="backButton">
            <fadv-button size="large" 
            (click)="onCancel()" 
            class="invite-form-button"
            name="partner-invite-back-button-1">Back
            </fadv-button>
        </fadv-grid-col>
        <fadv-grid-col alignment="{{nextButtonAlignment}}" id="nextButton">
            <fadv-button [loading]="loading"
             [active]="loading" 
             [disabled]="loading" 
             [disabled]="!this.form.valid"
             size="large" 
             variant='primary' 
             (click)="onSubmit()" 
             type="button"
             class="invite-form-button"
             name="partner-invite-next-button-1">Next
            </fadv-button>
        </fadv-grid-col>
    </fadv-grid-row>
</fadv-grid>

<!--begin modals for displaying applicant legal form templates to client-->
<fadv-modal #electronicsignaturemodal size="large">
    <fadv-modal-header>E-Signature Authorization</fadv-modal-header>
    <fadv-modal-body>
        <div data-min-width="600" style="height: 500px;overflow-y: auto;">
            <span [innerHTML]="candidateEsignAuth"></span>
        </div>
    </fadv-modal-body>
    <fadv-button fadvModalButton (click)="decline(1)" variant="neutral" name="partner-invite-back-button-2">Back</fadv-button>
    <fadv-button fadvModalButton (click)="electronicsignature()" variant="primary" name="partner-invite-next-button-2">Next</fadv-button>
</fadv-modal>

<fadv-modal #disclosuremodal size="large">
    <fadv-modal-header>Disclosure</fadv-modal-header>
    <fadv-modal-body>
        <div data-min-width="600" style="height: 500px;overflow-y: auto;">
            <span [innerHTML]="candidateDisclosure"></span>
        </div>
    </fadv-modal-body>
    <fadv-button fadvModalButton (click)="decline(2)" variant="neutral" name="partner-invite-close-button-1">Close</fadv-button>
    <fadv-button fadvModalButton (click)="disclosure()" variant="primary" name="partner-invite-next-button-3">Next</fadv-button>
</fadv-modal>

<fadv-modal #stateformsmodal size="large">
    <fadv-modal-header>State Specific Information</fadv-modal-header>
    <fadv-modal-body>
        <div data-min-width="600" style="height: 500px;overflow-y: auto;">
            <span [innerHTML]="candidateStateForms"></span>
        </div>
    </fadv-modal-body>
    <fadv-button fadvModalButton (click)="decline(3)" variant="neutral" name="partner-invite-back-button-3">Back</fadv-button>
    <fadv-button fadvModalButton (click)="stateForms()" variant="primary" name="partner-invite-next-button-4">Next</fadv-button>
</fadv-modal>

<fadv-modal #authorizationmodal size="large">
    <fadv-modal-header>Authorization</fadv-modal-header>
    <fadv-modal-body>
        <div data-min-width="600" style="height: 500px;overflow-y: auto;">
            <span [innerHTML]="candidateAuthorization"></span>
        </div>
    </fadv-modal-body>
    <fadv-checkbox [disabled]="true">Check here to receive a copy of your Consumer Report. (For U.S. addresses only)
    </fadv-checkbox>
    <fadv-button fadvModalButton (click)="decline(4)" variant="neutral" name="partner-invite-close-button-2">Close</fadv-button>
</fadv-modal>